import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/4f143559-26c7-49c6-9c31-c34b331d3b1d";
export const REGISTER_URL = "https://a.ntrk2.com/db1caa45-5287-4e0c-abd8-59a46c316ac4";

export const LOGIN_URL_MAP = {
  "www-big188play.com": "https://a.ntrk2.com/79de2ca3-77b2-4a16-91c4-ed2e15b322c4",
  "www-big188.net": "https://a.ntrk2.com/79de2ca3-77b2-4a16-91c4-ed2e15b322c4",
};

export const REGISTER_URL_MAP = {
  "www-big188play.com": "https://a.ntrk2.com/7aed6943-123b-43cd-9550-b483a6456d96",
  "www-big188.net": "https://a.ntrk2.com/7aed6943-123b-43cd-9550-b483a6456d96",
};

export const FLOATING_BANNER_URL = "http://b188thai.com/cs";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://big188.loadprkw2a.com/download?openExternalBrowser=1&id=l9txk3p23atg1zd";
